import React, { useCallback, useMemo } from 'react'
import classnames from 'classnames'
import { useLocalization } from '@/hooks/localization'
import { getCellStyles, preventAndStop } from './utils'
import { DefaultHeaderRenderer } from '@/components/report-tables/headers'

function LinkSoftTableRowHeaderCell (props) {
  const {
    isCurrent,
    columnSizes,
    onCollapseToggled,
    headerRenderer,
    ...metadata
  } = props
  const {
    row,
    className,
    childCount, depth,
    value, xCoord, yCoord,
    collapsed,
    // base metadata
    isBottomOfSandwichHeader
  } = metadata

  const { rtl } = useLocalization()
  const handleCollapseToggled = useCallback(() => {
    if (typeof onCollapseToggled === 'function') {
      onCollapseToggled({
        row: row,
        index: yCoord
      })
    }
  }, [onCollapseToggled, row, yCoord])
  const style = useMemo(() => getCellStyles(metadata, columnSizes, rtl), [columnSizes, metadata, rtl])
  const finalClassName = classnames(className, 'table-cell', 'table-row-header', 'htDimmed', 'ht_rowDepth-' + depth, {
    'current': isCurrent
  })
  const HeaderRenderer = headerRenderer || DefaultHeaderRenderer
  const content = (
    <React.Fragment>
      {childCount > 0 && !isBottomOfSandwichHeader && <React.Fragment>
        {collapsed && <span className='ht_expandButton' onClick={handleCollapseToggled} onMouseDown={preventAndStop}>+</span>}
        {!collapsed && <span className='ht_collapseButton' onClick={handleCollapseToggled} onMouseDown={preventAndStop}>-</span>}
      </React.Fragment>}
      <div className='table-header-content'>{(HeaderRenderer) ? <HeaderRenderer {...metadata} /> : value}</div>
    </React.Fragment>
  )

  const Cell = 'div'
  return <Cell
    style={style} className={finalClassName}
    title={value}
    data-x={xCoord} data-y={yCoord}
  >
    {content}
  </Cell>
}

export {
  LinkSoftTableRowHeaderCell
}



// WEBPACK FOOTER //
// ./src/components/report-tables/core/rowHeaderCell.js